const withDefault = (value, fallback) =>
  typeof value === "boolean" ? value : fallback;

export const resolveWorkoutCardUiFlags = ({
  mode = "planification",
  forceEditMode,
  showWorkoutDate,
  showWorkoutMoreMenu,
  showWorkoutFooter,
  showWorkoutFooterReorder,
  showWorkoutFooterDelete,
  showDoneButton,
} = {}) => {
  const isLibraryMode = mode === "library";

  const resolvedShowWorkoutFooter = withDefault(showWorkoutFooter, true);

  return {
    forceEditMode: withDefault(forceEditMode, isLibraryMode),
    showWorkoutDate: withDefault(showWorkoutDate, !isLibraryMode),
    showWorkoutMoreMenu: withDefault(showWorkoutMoreMenu, !isLibraryMode),
    showWorkoutFooter: resolvedShowWorkoutFooter,
    showWorkoutFooterReorder:
      resolvedShowWorkoutFooter &&
      withDefault(showWorkoutFooterReorder, !isLibraryMode),
    showWorkoutFooterDelete:
      resolvedShowWorkoutFooter &&
      withDefault(showWorkoutFooterDelete, !isLibraryMode),
    showDoneButton: withDefault(showDoneButton, !isLibraryMode),
  };
};

